import React, {useEffect, useState, useContext} from 'react';
import ProfileDescription from './ProfileDescription';
import ProfileForm from './ProfileForm';
import { appContext } from "../../AppContext";
import { Alert, Tabs } from 'antd';
import { useFetch } from './../../utils/hooks/useFetch'
import ProfileEmailNofitications from './ProfileEmailNotifications';
const { TabPane } = Tabs;


export default function Profile({
    chosenLarper,
    refresh: propsRefresh,
 }) {

    const [originalLarper, setOriginalLarper] = useState(undefined)
    const [appState, AppDispatch] = useContext(appContext);
    const [somethingChanged, setSomethingChanged] = useState(false)
    const [doFetch] = useFetch();

    useEffect(() => {
        if(chosenLarper) {
            setOriginalLarper(chosenLarper);
            return;
        }

        const newLarper = {
            name:appState.user.name,
            emailAddress:appState.user.emailAddress, 
            userRoles:appState.user.userRoles,
            isAdmin:appState.user.isAdmin,
            isSlOfStory:appState.isSlOfStory,
            emailConfirmed:appState.user.emailConfirmed,
            id:appState.user.id,
            emailNotifications:appState.user.emailNotifications,
            privateInfo:appState.user.privateInfo
        }

        setOriginalLarper(newLarper);
        setSomethingChanged(false);
    }, // eslint-disable-next-line
    [chosenLarper, appState.user])

    function refresh() {

        setSomethingChanged(false);
        
        if(chosenLarper) {
            propsRefresh()
            return;
        }

        const url = `/api/Account/GetCurrentUser`;

        doFetch(url)
            .then((response) => {
                if(response.isSuccess) {
                    AppDispatch({ type: "LOGIN", payload: response.result })
                }
            })

    }

    function setChangeAlert() {

        if(somethingChanged === false) {
            return null;
        }

        return (
            <>
                <br />
                <Alert
                    message="Don't forget to press 'Update Profile' to save the changes you made "
                    type="info"
                    showIcon
                />
                <br />
            </>
        )
    }

    if(originalLarper === undefined) {
        return null
    }

    return (
        <>
            {setChangeAlert()}
            <ProfileDescription 
                originalLarper={originalLarper}
            />

            <Tabs defaultActiveKey="1">
                <TabPane tab="Basic data" key="1">

                    <ProfileForm 
                        originalLarper={originalLarper}
                        refresh={refresh}
                        setSomethingChanged={setSomethingChanged}
                        somethingChanged={somethingChanged}
                    />
                </TabPane>
                <TabPane tab="Email notifications" key="2">
                    <ProfileEmailNofitications 
                        originalLarper={originalLarper}
                        refresh={refresh}
                    />
                </TabPane>
            </Tabs>


        </>
    )
}